<script>
	'use strict'

  import Popup from './Popup.svelte';
  import FileManagement from './FileManagement.svelte';
	import Settings from './Settings.svelte';
	import ExportTileMap from './ExportTileMap.svelte';
</script>


<Popup btnName={'FILE'} sectionTitle={'FILE MANAGEMENT'}>
  <FileManagement></FileManagement>
</Popup>
<Popup btnName={'SETTINGS'} sectionTitle={'SETTINGS'}>
  <Settings></Settings>
</Popup>
<Popup btnName={'GET TILEMAP'} sectionTitle={'Final map!'}>
  <ExportTileMap></ExportTileMap>
</Popup>
